import type { SelectHTMLAttributes } from "react";

/** Native keyboard and picker behaviour; the visible value can wrap on narrow screens. */
export function WrappingNativeSelect({
  displayValue,
  className = "",
  children,
  ...props
}: SelectHTMLAttributes<HTMLSelectElement> & { displayValue: string }) {
  return (
    <span className={`relative block min-w-0 ${className}`}>
      <span
        aria-hidden="true"
        className={`block min-h-11 whitespace-normal break-words rounded-lg border border-slate-300 bg-white py-2 pl-3 pr-9 text-sm text-slate-900 ${props.disabled ? "bg-slate-50" : ""}`}
      >
        {displayValue}
      </span>
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="pointer-events-none absolute right-3 top-3 h-5 w-5 text-slate-600"
      >
        <path
          fillRule="evenodd"
          d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.17l3.71-3.94a.75.75 0 1 1 1.08 1.04l-4.25 4.5a.75.75 0 0 1-1.08 0l-4.25-4.5a.75.75 0 0 1 .02-1.06Z"
          clipRule="evenodd"
        />
      </svg>
      <select
        {...props}
        className="peer absolute inset-0 min-h-11 w-full cursor-pointer opacity-0 disabled:cursor-default"
      >
        {children}
      </select>
      <span
        aria-hidden="true"
        className="peer-focus-visible:ring-brand-500 pointer-events-none absolute inset-0 rounded-lg peer-focus-visible:ring-2"
      />
    </span>
  );
}
